// Recovered compiled webpack factory 19904. Edit this function expression; run npm run build.
(e, t, r) => {
  r.d(t, { A: () => i });
  var a = r(12115),
    n = r(84375);
  let l = (e) => {
    let t = e.replace(/^([A-Z])|[\s-_]+(\w)/g, (e, t, r) =>
      r ? r.toUpperCase() : t.toLowerCase(),
    );
    return t.charAt(0).toUpperCase() + t.slice(1);
  };
  var s = r(75477);
  let i = (e, t) => {
    let r = (0, a.forwardRef)((r, i) => {
      let { className: d, ...o } = r;
      return (0, a.createElement)(s.default, {
        ref: i,
        iconNode: t,
        className: (0, n.z)(
          `lucide-${l(e)
            .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
            .toLowerCase()}`,
          `lucide-${e}`,
          d,
        ),
        ...o,
      });
    });
    return ((r.displayName = l(e)), r);
  };
}
